"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterOptionSelector = exports.setByEnRu = exports.RU_ALPHABET = exports.findLayoutKeyboard = exports.setByRuEn = exports.EN_TO_RU_MAP = exports.RU_TO_EN_MAP = void 0;
const RU_TO_EN_MAP = {
    й: 'q',
    ц: 'w',
    у: 'e',
    к: 'r',
    е: 't',
    н: 'y',
    г: 'u',
    ш: 'i',
    щ: 'o',
    з: 'p',
    х: '[',
    ъ: ']',
    ф: 'a',
    ы: 's',
    в: 'd',
    а: 'f',
    п: 'g',
    р: 'h',
    о: 'j',
    л: 'k',
    д: 'l',
    ж: ';',
    э: "'",
    я: 'z',
    ч: 'x',
    с: 'c',
    м: 'v',
    и: 'b',
    т: 'n',
    ь: 'm',
    б: ',',
    ю: '.',
    ё: '`',
};
exports.RU_TO_EN_MAP = RU_TO_EN_MAP;
const EN_TO_RU_MAP = {
    q: 'й',
    w: 'ц',
    e: 'у',
    r: 'к',
    t: 'е',
    y: 'н',
    u: 'г',
    i: 'ш',
    o: 'щ',
    p: 'з',
    '[': 'х',
    ']': 'ъ',
    a: 'ф',
    s: 'ы',
    d: 'в',
    f: 'а',
    g: 'п',
    h: 'р',
    j: 'о',
    k: 'л',
    l: 'д',
    ';': 'ж',
    "'": 'э',
    z: 'я',
    x: 'ч',
    c: 'с',
    v: 'м',
    b: 'и',
    n: 'т',
    m: 'ь',
    ',': 'б',
    '.': 'ю',
    '/': '.',
    '`': 'ё',
};
exports.EN_TO_RU_MAP = EN_TO_RU_MAP;
const RU_ALPHABET = 'аАбБвВгГдДеЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧшШщЩъЪыЫьЬэЭюЮяЯ';
exports.RU_ALPHABET = RU_ALPHABET;
function findLayoutKeyboard(symbol) {
    return RU_ALPHABET.includes((symbol || '').toLowerCase()) ? 'RU' : 'EN';
}
exports.findLayoutKeyboard = findLayoutKeyboard;
function setByEnRu(str) {
    return (str || '').toLowerCase().replace(/[a-z/,.`;\'\]\[]/g, function (x) {
        return x == x.toLowerCase() ? EN_TO_RU_MAP[x] : EN_TO_RU_MAP[x.toLowerCase()].toUpperCase();
    });
}
exports.setByEnRu = setByEnRu;
function setByRuEn(str) {
    const regExp = new RegExp(`[${RU_ALPHABET}]`, 'g');
    const newStr = (str || '').toLowerCase().replace(regExp, function (x) {
        return x == x.toLowerCase() ? RU_TO_EN_MAP[x] : RU_TO_EN_MAP[x.toLowerCase()].toUpperCase();
    });
    return newStr;
}
exports.setByRuEn = setByRuEn;
function filterOptionSelector(option, rawInput) {
    var _a, _b, _c;
    let is;
    const layout = findLayoutKeyboard((rawInput || '')[0]);
    if (layout === 'RU') {
        is = (_a = option.label) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(setByRuEn(rawInput === null || rawInput === void 0 ? void 0 : rawInput.toLowerCase()));
    }
    else {
        is = (_b = option.label) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(setByEnRu(rawInput === null || rawInput === void 0 ? void 0 : rawInput.toLowerCase()));
    }
    return is || ((_c = option.label) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(rawInput === null || rawInput === void 0 ? void 0 : rawInput.toLowerCase()));
}
exports.filterOptionSelector = filterOptionSelector;
//# sourceMappingURL=keyboardRuOrEn.js.map